var _jsxFileName = "/src/main/react/src/main/app/components/common/UploadButton.js";
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import { Button, Fade } from '@material-ui/core';
import { UPLOAD } from "../Routes";
import { Q_STRING, ID_SPACE } from "../domain/constants";
import Util from "../../util/Util";
import Tooltip from "@material-ui/core/Tooltip";
const styles = theme => ({
  lightTooltip: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
    fontSize: 11
  }
});

/**
 * A button which always redirects to the /upload page.
 */
class UploadButton extends Component {
  constructor(props) {
    super(props);
    this.routeUpload = this.routeUpload.bind(this);
    this.state = {
      adiId: props.adiId != null ? props.adiId : null,
      merlinId: props.merlinId != null ? props.merlinId : null,
      title: props.title != null ? props.title : null,
      enabled: false // disabled by default
    };
    this.determineUploadEnabled().then(res => {
      this.setState({
        enabled: res
      });
    });
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.state.enabled !== prevState.enabled) {
      this.determineUploadEnabled().then(res => {
        this.setState({
          enabled: res
        });
      });
    }
  }
  async determineUploadEnabled() {
    const _this$state = this.state,
      adiId = _this$state.adiId,
      merlinId = _this$state.merlinId;
    let entityProvider, entityId;
    if (adiId != null && adiId !== '') {
      entityProvider = ID_SPACE.ADI;
      entityId = adiId;
    } else if (merlinId != null) {
      entityProvider = ID_SPACE.MERLIN;
      entityId = merlinId;
    } else {
      // We probably got to the page by title. /is/visible check doesn't support title
      return true;
    }

    // upload button should be enabled if the entity is visible to the user
    return await Util.isVisibleForUser(entityProvider, entityId, this.props);
  }
  routeUpload() {
    let path = this.makePath();
    this.props.history.push(path);
  }
  makePath() {
    let path = UPLOAD;
    let firstIsSet = false;
    if (this.state.adiId) {
      path += "?".concat(Q_STRING.ADI_ID, "=").concat(this.state.adiId);
      firstIsSet = true;
    }
    if (this.state.merlinId) {
      path += (firstIsSet ? '&' : '?') + "".concat(Q_STRING.MERLIN_ID, "=").concat(this.state.merlinId);
      firstIsSet = true;
    }
    if (this.state.title) {
      path += (firstIsSet ? '&' : '?') + "".concat(Q_STRING.TITLE, "=").concat(this.state.title);
    }
    return path;
  }
  render() {
    const classes = this.props.classes;
    const disabled = !this.state.enabled;
    if (disabled === true) {
      // <Button> objects don't fire events when they're disabled. You have to wrap them in this useless div
      // nevermind that tooltips around Buttons are generally most useful when the button is disabled...
      return /*#__PURE__*/React.createElement(Tooltip, {
        title: "You are not permitted to upload to this entity.",
        TransitionComponent: Fade,
        classes: {
          tooltip: classes.lightTooltip
        },
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 98,
          columnNumber: 17
        }
      }, /*#__PURE__*/React.createElement("div", {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 99,
          columnNumber: 21
        }
      }, /*#__PURE__*/React.createElement(Button, {
        variant: "contained",
        disabled: true,
        elevation: 0,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 100,
          columnNumber: 25
        }
      }, "Upload")));
    } else {
      return /*#__PURE__*/React.createElement(Button, {
        variant: "contained",
        color: "primary",
        onClick: () => this.routeUpload(),
        elevation: 0,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 106,
          columnNumber: 17
        }
      }, "Upload");
    }
  }
}

// These exports kind of get a little confusing, but I don't think it matters what order they're in as long as you include all parts
export default withStyles(styles)(withRouter(UploadButton));